import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/Hadeeb/Documents/js/react/reactive/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "store"
    }}>{`Store`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Stores the state and event handlers.`}</p>
    </blockquote>
    <p>{`Create a store using `}<inlineCode parentName="p">{`createStore`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`createStore`}</inlineCode>{` accepts 2 parameters - event handlers and initial state.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { createStore } from "@hadeeb/reactive";

const events = {
  INCREMENT({ state }) {
    state.counter++;
  },
  DECREMENT({ state }) {
    state.counter--;
  },
  UPDATE_COUNTER({ state }, payload) {
    state.counter = state.counter + payload;
  },
  async ASYNC_UPDATE({ dispatch }) {
    const count = await fetch(
      "https://www.random.org/integers/?num=1&min=1&max=100&col=1&base=10&format=plain&rnd=new"
    ).then(data => data.text());
    dispatch("UPDATE_COUNTER", count);
  }
};

const initialState = { counter: 0 };

const store = createStore(events, initialState);
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`store.getState()`}</inlineCode></p>
        <p parentName="li">{`returns the current state`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`store.dispatch(event,payload)`}</inlineCode></p>
        <p parentName="li">{`dispatches an action and an optional payload as second argument`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      